/*
|--------------------------------------------------------------------------
| Utilities: Accordion
|--------------------------------------------------------------------------
*/
/**
 * Accordion functionality
 * @memberof utilities
 * @namespace utilities.accordion
 * @inner
 */
__gh__webApp.utilities.accordion = {

	/**
	 * Initialize
	 * @memberof utilities.accordion
	 * @method init
	 */
	 "init": function(){
		 this.loadAllAccordions();
	 },


	/**
	 * Load all accordions on a page
	 * @memberof utilities.accordion
	 * @method loadAllAccordions
	 */
	"loadAllAccordions": function(){
		var ghAccordion = this;

		$("[data-gh-accordion-loaded=false]").each(function(){
			var $accordion  = $(this),
			  	options		= {
				  "toggleDOM": $accordion.data('gh-accordion-toggle-dom'),
				  "panelDOM" : $accordion.data('gh-accordion-panel-dom'),
				};

			//Set loaded to true so it's not called again.
			$accordion.attr("data-gh-accordion-loaded",true);
			ghAccordion.bindEvents(options);
		});
	},


	/**
	 * Bind events
	 * @memberof utilities.accordion
	 * @method bindEvents
	 * @param {object} options
	 * @param {string} options.toggleDOM - DOM that contains the elements that will be clicked to toggle the open and close a panel
	 * @param {string} options.panelDOM - Individual panels
	 * @example
	 * &lt;ul data-gh-accordion-loaded="false" data-gh-accordion-panel-dom="#drawer-nav-sections .subnav" data-gh-accordion-toggle-dom="#drawer-nav-sections &gt; li &gt; a"  id="drawer-nav-sections"&gt;
	 * 	&lt;li&gt;
	 * 		&lt;a class="noSubLinks" href="http://www.pjstar.com" target="_top"&gt;Home&lt;/a&gt;
	 * 	&lt;/li&gt;
	 * 	&lt;li&gt;
	 * 		&lt;a href="http://www.pjstar.com/sports"&gt;&lt;span class="nav-category"&gt;Sports&lt;/span&gt;&lt;span class="caret"&gt;&lt;/span&gt;&lt;/a&gt;
	 * 		&lt;ul class="subnav" style="display: none;"&gt;
	 * 			&lt;li id="navLink-TEST-"&gt;
	 * 				&lt;a href="http://www.pjstar.com/preps" target="_top"&gt;Preps&lt;/a&gt;
	 * 			&lt;/li&gt;
	 * 		&lt;/ul&gt;
	 * 	&lt;/li&gt;
	 * 	&lt;li&gt;
	 * 		&lt;a href="http://www.pjstar.com/entertainment"&gt;&lt;span class="nav-category"&gt;Entertainment&lt;/span&gt;&lt;span class="caret"&gt;&lt;/span&gt;&lt;/a&gt;
	 * 		&lt;ul class="subnav" style="display: none;"&gt;
	 * 			&lt;li id="navLink-TEST-"&gt;
	 * 				&lt;a href="http://www.pjstar.com/entertainment/books" target="_top"&gt;Books&lt;/a&gt;
	 * 			&lt;/li&gt;
	 * 		&lt;/ul&gt;
	 * 	&lt;/li&gt;
	 * &lt;/ul&gt;
	 */
	 "bindEvents": function(options){
		var toggleDOM 	= (options.toggleDOM) 	? options.toggleDOM : null,
		    panelDOM 	= (options.panelDOM) 	? options.panelDOM : null;

		var $allPanels = $(panelDOM).hide();

		$(document).on("click",toggleDOM,(function(e) {
			if($(e.target).is('.nav-category')) return true;
			$allPanels.not(this).slideUp();
			if (!$(this).next(panelDOM).is(':visible')){
				$(this).next(panelDOM).slideDown();
			}
			return false;
		}));
	}

};
